import { TDesignJourney } from './types'

const DESIGN_PATHS: Record<string, TDesignJourney> = {
  BRIEFING_FORM: 'briefing',
  DESIGN_UPLOAD: 'upload',
  ONLINE_EDITOR: 'editor',
  SKIP_ARTWORK: 'skip-artwork',
  RAQ_SKIP_ARTWORK: 'raq-skip-artwork',
}

export { DESIGN_PATHS }
